import { Injectable } from '@angular/core';
import {
  State,
  Action,
  StateContext,
  Selector,
  NgxsAfterBootstrap,
} from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { User } from '../../models/user.model';
import { Me, ClearMe } from './user.actions';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { Title } from '@angular/platform-browser';

export interface UserStateModel {
  user?: User;
}

@State<UserStateModel>({
  name: 'user',
  defaults: {},
})
@Injectable()
export class UserState implements NgxsAfterBootstrap {
  constructor(private userService: UserService, private titleService: Title) {}

  @Selector()
  static me(state: UserStateModel) {
    return state.user;
  }

  @Selector()
  static advancedConnectionsPermission(state: UserStateModel): boolean {
    return state.user?.permissions.bot.advanced_connections;
  }

  ngxsAfterBootstrap({ dispatch }: StateContext<UserStateModel>): void {
    if (AuthService.isAuthenticated()) {
      dispatch(Me);
    }
  }

  @Action(Me)
  me({ getState, setState }: StateContext<UserStateModel>, {}: Me) {
    return this.userService.me().pipe(
      tap((result) => {
        if (result.status) {
          const state = getState();
          delete result.status;
          setState({
            ...state,
            user: result,
          });

          this.titleService.setTitle(result.portal.title);
        }
      })
    );
  }

  @Action(ClearMe)
  clearMe(
    { getState, setState }: StateContext<UserStateModel>,
    {}: ClearMe
  ): void {
    const state = getState();
    setState({
      ...state,
      user: undefined,
    });
  }
}
